/* Built In Imports */
import { useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/Headings/SectionTitle';
import HtmlBlock from '@components/UI/HtmlBlock';
import MidContainer from '@Layout/MidContainer';

/* Services */

/**
 * @param section.section
 * @param {object} section
 * @param {object} csrData
 * @param section.csrData
 * @returns
 */
const NeedSupport = ({ section, csrData }) => {
  let onlineSupport = csrData => {
    // consoleLog('NeedSupport', csrData);
    onlineSupport = document.querySelector('.onlinecontact');
    let onlineSupportEmail = '';
    if (csrData.email) {
      // consoleLog('NeedSupport csrData', csrData);
      onlineSupportEmail = ` <a href=mailto:${csrData.email}>${csrData.email}</a>`;
      onlineSupport.innerHTML = onlineSupportEmail;
    }
    if (csrData) {
      csrData.email?.includes('@')
        ? (onlineSupportEmail = ` <a href=mailto:${csrData?.email || ''}>${
            csrData?.email || ''
          }</a>`)
        : (onlineSupportEmail = ` <a href=${
            csrData.email || ''
          }>Click here</a>`);
      if (onlineSupport) {
        onlineSupport.innerHTML = onlineSupportEmail;
      }
    }
  };

  useEffect(() => {
    onlineSupport(csrData);
  }, [csrData]);

  return (
    <MidContainer w={'970'}>
      <Box mt="0" pb={{ base: '60px', md: '80px' }} id="needsupport">
        <SectionTitle titleObj={section?.sectionContent[0]} />
        <Box pt="40px">
          <HtmlBlock sectionContent={section?.sectionContent[1]} />
        </Box>
      </Box>
    </MidContainer>
  );
};

export default NeedSupport;
